<template>
    <div id="newbuilding">
        <nav>
            <div class="leftNav">
                <div class="innerNav">
                    <img class="navLogout" v-on:click="openNav()" src="/assets/burger.png" alt="burger" />
                </div>
            </div>
            <center>
                <img class="main" v-on:click="reload()" src="/assets/logo.png" alt="SO" />
            </center>
            <div class="rightNav">
                <div class="innerNav">
                    <span class="pNav">
                        {{Name}}
                    </span>
                    <img class="logoNav" src="/assets/adpr.png" alt="ADPR" />
                </div>
            </div>
            <div class="sideNav" :style="{ width: navWidth + 'px' }">
                <div class="leftNav">
                    <div class="innerNav">
                        <img class="navLogout" v-on:click="openNav()" src="/assets/burgerwhite.png" alt="burger" />
                    </div>
                </div>
                <div v-if="navMenuVisible" class="navsidecontent">
                    <div class="navtitle noborder">
                        Gérer les biens et demandes
                    </div>
                    <div v-on:click="refresh" class="navsubtitle">
                        Créer un nouveau bien
                    </div>
                    <div v-on:click="goToBuildingPage" class="navsubtitle">
                        Consulter/Modifier les biens et demandes
                    </div>
                    <div class="navtitle">
                        Plannings
                    </div>
                    <div v-on:click="goToPlanningPage" class="navsubtitle">
                        Consulter/Modifier les plannings
                    </div>
                    <div v-on:click="goToTimeSheetPage" class="navsubtitle">
                        Fiches horaires
                    </div>
                    <div class="navtitle">
                        Groupes
                    </div>
                    <div v-on:click="goToNewGroupPage" class="navsubtitle">
                        Ajouter un groupe
                    </div>
                    <div v-on:click="goToAllGroupPage" class="navsubtitle">
                        Voir/Modifier les groupes
                    </div>
                    <div class="navtitle">
                        Utilisateurs
                    </div>
                    <div v-on:click="goToNewUserPage" class="navsubtitle">
                        Ajouter un utilisateur
                    </div>
                    <div v-on:click="goToAllUserPage" class="navsubtitle">
                        Voir/Modifier les utilisateurs
                    </div>
                    <div v-on:click="logout()" class="navtitle logout">
                        Déconnexion
                    </div>
                </div>
            </div>
        </nav>
        <div class="outercircle">
            <div class="homeName">
                {{Name}}
            </div>
            <div id="circle"></div>
        </div>
        <h1>
            <button v-on:click="backbtn()" class="btnBack">
                <font-awesome-icon icon="arrow-alt-circle-left" />
            </button>
            Nouveau bien
        </h1>
        <input type="file" ref="file" @change="readURL" style="display: none">
        <img v-on:click="$refs.file.click()" class="imgCard" id="mainPic" :src="imgUrl" alt="SO" />
        <div class="container">
            <div class="textline">
                <b class="textLen">Type : </b>
                <input class="radioBtn" type="radio" name="isJointOwnershipRadio" :value="true" v-model="building.isJointOwnership">
                <span>Copropriété</span>
                <input class="radioBtn" type="radio" name="isJointOwnershipRadio" :value="false" v-model="building.isJointOwnership" checked>
                <span>Individuel</span><br>
            </div>
            <div class="textline">
                <b class="textLen">Résidence :</b>
                <input class="inputTxt" type="text"  v-model="building.residence" >
            </div>
            <div class="textline">
                <b class="textLen">Adresse<i style="color:red;">*</i>&nbsp; :</b>
                <input class="inputTxt" type="text"  v-model="building.buildingAddress.streetName" >
            </div>
            <div class="textline">
                <b class="textLen">Code postal<i style="color:red;">*</i>&nbsp; :</b>
                <input class="inputTxt" type="text"  v-model="building.buildingAddress.postalCode" >
            </div>
            <div class="textline">
                <b class="textLen">Ville<i style="color:red;">*</i>&nbsp; :</b>
                <input class="inputTxt" type="text"  v-model="building.buildingAddress.city" >
            </div>
            <div class="textline">
                <b class="textLen">Etage :</b>
                <input class="inputTxt" type="text"  v-model="building.etage" >
            </div>
            <div class="textline">
                <b class="textLen">Complément d'adresse :</b>
                <input class="inputTxt" type="text"  v-model="building.complement" >
            </div>
            <div class="textline allselects">
                <div class="inlineBlock" v-for="indexFor in userAllowed " :key="indexFor">
                     <b v-if="indexFor===1" class="textLen">Droit d'accès :</b>
                     <b v-else class="textLen"></b>
                    <select id="inChargeSelect" class="inputTxt select" v-model="allAllowedData[indexFor - 1]">
                        <option class="inputTxt" :value="undefined" selected>
                            Sélectionner
                        </option>
                        <option class="inputTxt" v-for="(item, index) in accessEntities" :key="index" :value="item.idWeweb">
                            {{item.address.firstName +" "+item.address.lastName}}
                        </option>
                    </select>
                </div>  
                <div class="blockBtn">
                    <b class="textLen"></b>
                    <button class="btnNewBtn" v-on:click="userAllowedInc()"><font-awesome-icon icon="plus" />
                    </button>
                    Ajouter  
                </div>    
            </div>
            <div class="textline allselects">
                <div class="inlineBlock" v-for="indexFor2 in inChargeNb " :key="indexFor2">
                    <b v-if="indexFor2===1" class="textLen">Personne en charge :</b>
                    <b v-else class="textLen"></b>
                    <select id="allowedUserSelect" class="inputTxt select" v-model="building.incharge[indexFor2 - 1]">
                        <option class="inputTxt" :value="undefined" selected>
                            Sélectionner
                        </option>
                        <option class="inputTxt" v-for="(itemIncharge, indexIncharge) in inchargeToSelect" :key="indexIncharge" :value="{idWeweb:itemIncharge.idWeweb}">
                            {{itemIncharge.address.firstName +" "+itemIncharge.address.lastName}}
                        </option>
                    </select>
                </div>
                <div class="blockBtn">
                    <b class="textLen"></b>
                    <button class="btnNewBtn" v-on:click="inChargeNbInc()"><font-awesome-icon icon="plus" />
                    </button>
                    Ajouter  
                </div>  
            </div>
            <div class="textline">
                <b>Bloc notes :</b>
                <textarea rows="8" class="inputTxt area" type="text"  v-model="building.note" ></textarea>
            </div>
        </div>
        <h3>Coordonnées Propriétaire</h3>
        <div class="container">
            <div class="textline">
                <b class="textLen">NOM :</b>
                <input class="inputTxt" type="text"  v-model="building.ownerAddress.lastName" >
            </div>
            <div class="textline">
                <b class="textLen">Prénom :</b>
                <input class="inputTxt" type="text"  v-model="building.ownerAddress.firstName" >
            </div>
            <div class="textline">
                <b class="textLen">Adresse :</b>
                <input class="inputTxt" type="text"  v-model="building.ownerAddress.streetName" >
            </div>
            <div class="textline">
                <b class="textLen">Code postal :</b>
                <input class="inputTxt" type="text"  v-model="building.ownerAddress.postalCode" >
            </div>
            <div class="textline">
                <b class="textLen">Ville :</b>
                <input class="inputTxt" type="text"  v-model="building.ownerAddress.city" >
            </div>
            <div class="textline">
                <b class="textLen">Téléphone :</b>
                <input class="inputTxt" type="text"  v-model="building.ownerAddress.phoneNumber" >
            </div>
            <div class="textline">
                <b class="textLen">Email :</b>
                <input class="inputTxt" type="text"  v-model="building.ownerAddress.emailAddress" >
            </div>
            <div class="textline">
                <b class="textLen">Société :</b>
                <input class="inputTxt" type="text"  v-model="building.ownerAddress.company" >
            </div>
        </div>
        <h3>Coordonnées Locataire</h3>
        <div v-for="(itemOcc, indexOcc) in building.occupantAddress" :key="indexOcc">
            <div class="container">
                <div class="textline">
                    <b class="textLen">NOM :</b>
                    <input class="inputTxt" type="text"  v-model="itemOcc.lastName" >
                </div>
                <div class="textline">
                    <b class="textLen">Prénom :</b>
                    <input class="inputTxt" type="text"  v-model="itemOcc.firstName" >
                </div>
                <div class="textline">
                    <b class="textLen">Adresse :</b>
                    <input class="inputTxt" type="text"  v-model="itemOcc.streetName" >
                </div>
                <div class="textline">
                    <b class="textLen">Code postal :</b>
                    <input class="inputTxt" type="text"  v-model="itemOcc.postalCode" >
                </div>
                <div class="textline">
                    <b class="textLen">Ville :</b>
                    <input class="inputTxt" type="text"  v-model="itemOcc.city" >
                </div>
                <div class="textline">
                    <b class="textLen">Téléphone :</b>
                    <input class="inputTxt" type="text"  v-model="itemOcc.phoneNumber" >
                </div>
                <div class="textline">
                    <b class="textLen">Email :</b>
                    <input class="inputTxt" type="text"  v-model="itemOcc.emailAddress" >
                </div>
                <div class="textline">
                    <b class="textLen">Société :</b>
                    <input class="inputTxt" type="text"  v-model="itemOcc.company" >
                </div>
            </div>
        </div>
        <div class="blockBtn">
            <button class="btnNewBtn" v-on:click="occupantAddressNbInc()">
                <font-awesome-icon icon="plus" />
            </button>
            Ajouter  
        </div>  
        <h3>Coordonnées Syndic</h3>
        <div class="container">
            <div class="textline">
                <b class="textLen">NOM :</b>
                <input class="inputTxt" type="text"  v-model="building.syndicAddress.lastName" >
            </div>
            <div class="textline">
                <b class="textLen">Prénom :</b>
                <input class="inputTxt" type="text"  v-model="building.syndicAddress.firstName" >
            </div>
            <div class="textline">
                <b class="textLen">Adresse :</b>
                <input class="inputTxt" type="text"  v-model="building.syndicAddress.streetName" >
            </div>
            <div class="textline">
                <b class="textLen">Code postal :</b>
                <input class="inputTxt" type="text"  v-model="building.syndicAddress.postalCode" >
            </div>
            <div class="textline">
                <b class="textLen">Ville :</b>
                <input class="inputTxt" type="text"  v-model="building.syndicAddress.city" >
            </div>
            <div class="textline">
                <b class="textLen">Téléphone :</b>
                <input class="inputTxt" type="text"  v-model="building.syndicAddress.phoneNumber" >
            </div>
            <div class="textline">
                <b class="textLen">Email :</b>
                <input class="inputTxt" type="text"  v-model="building.syndicAddress.emailAddress" >
            </div>
            <div class="textline">
                <b class="textLen">Société :</b>
                <input class="inputTxt" type="text"  v-model="building.syndicAddress.company" >
            </div>
        </div>
        <h3>Coordonnées Gérance locative</h3>
        <div class="container">
            <div class="textline">
                <b class="textLen">NOM :</b>
                <input class="inputTxt" type="text"  v-model="building.managerAddress.lastName" >
            </div>
            <div class="textline">
                <b class="textLen">Prénom :</b>
                <input class="inputTxt" type="text"  v-model="building.managerAddress.firstName" >
            </div>
            <div class="textline">
                <b class="textLen">Adresse :</b>
                <input class="inputTxt" type="text"  v-model="building.managerAddress.streetName" >
            </div>
            <div class="textline">
                <b class="textLen">Code postal :</b>
                <input class="inputTxt" type="text"  v-model="building.managerAddress.postalCode" >
            </div>
            <div class="textline">
                <b class="textLen">Ville :</b>
                <input class="inputTxt" type="text"  v-model="building.managerAddress.city" >
            </div>
            <div class="textline">
                <b class="textLen">Téléphone :</b>
                <input class="inputTxt" type="text"  v-model="building.managerAddress.phoneNumber" >
            </div>
            <div class="textline">
                <b class="textLen">Email :</b>
                <input class="inputTxt" type="text"  v-model="building.managerAddress.emailAddress" >
            </div>
            <div class="textline">
                <b class="textLen">Société :</b>
                <input class="inputTxt" type="text"  v-model="building.managerAddress.company" >
            </div>
        </div>
        <div class="btnContainer">
            <button v-on:click="uploadBuilding()" class="btn">Valider</button>
        </div>
        
            <modal height="250px" width="400px" name="validationModal">
                <div class="modalDiv">  
                    <div class="txtDiv">
                        <img class="modalTxt" :src="imgValidation"/>
                    </div>  
                    <div class="txtDiv">
                        <span class="modalTxt">{{validationPhrase}}</span>
                    </div>    
                    <button class="docBtn3" type="button" v-on:click="okButton()">OK</button>   
                </div>    
            </modal>
    </div>
</template>

<script>
    import axios from 'axios';
    export default {
        name: 'Newbuilding',
        data() {
            return {
                Name:"ADPR",
                navWidth:0,
                navMenuVisible:false,
                filAriane: "",
                validationPhrase: "Le Nouveau bien a été correctement enregistré",
                imgValidation: "/assets/right.png",
                files : [],
                allBuldingName: [],
                inChargeNb: 1,
                userAllowed: 1,
                allAllowedData:     [],
                userdataToSelect:   [],
                groupdataToSelect:  [],
                inchargeToSelect:   [],
                building: {
                        "userdata":           [],
                        "groupdata":          [],
                        "incharge":           [],
                        "ownerAddress":        {
                            "streetNb":      "",
                            "streetName":    "",
                            "postalCode" :   "",
                            "city" :         "",
                            "firstName" :    "",
                            "lastName" :     "",
                            "phoneNumber" :  "",
                            "company" :      "",
                            "emailAddress" : ""
                        },
                        "occupantAddress":    [{
                            "streetNb":      "",
                            "streetName":    "",
                            "postalCode" :   "",
                            "city" :         "",
                            "firstName" :    "",
                            "lastName" :     "",
                            "phoneNumber" :  "",
                            "company" :      "",
                            "emailAddress" : ""
                        }],
                        "buildingAddress":     {
                            "streetNb":      "",
                            "streetName":    "",
                            "postalCode" :   "",
                            "city" :         "",
                            "firstName" :    "",
                            "lastName" :     "",
                            "phoneNumber" :  "",
                            "company" :      "",
                            "emailAddress" : ""
                        },
                        "syndicAddress":       {
                            "streetNb":      "",
                            "streetName":    "",
                            "postalCode" :   "",
                            "city" :         "",
                            "firstName" :    "",
                            "lastName" :     "",
                            "phoneNumber" :  "",
                            "company" :      "",
                            "emailAddress" : ""
                        },
                        "managerAddress":      {
                            "streetNb":      "",
                            "streetName":    "",
                            "postalCode" :   "",
                            "city" :         "",
                            "firstName" :    "",
                            "lastName" :     "",
                            "phoneNumber" :  "",
                            "company" :      "",
                            "emailAddress" : ""
                        },
                        "inquiry":           [],
                        "isJointOwnership":  true,
                        "name":              "",
                        "residence":         "",
                        "complement":        "",
                        "note":              "",
                        "type":              "",
                        "title":             "",
                        "etage":             ""
                    
                },
                imgUrl : "/assets/add_picture_long.png",
                lastModified: {},
                fileType: "image/png",
                resizedFile: {},
                imageType: "",
            };
        },
        computed: {
            accessEntities(){
                return this.userdataToSelect.concat(this.groupdataToSelect)
            }
        },
        watch: {
            allAllowedData : function (){
                this.building.groupdata = [];
                this.building.userdata = [];
                for(var i=0; i<this.allAllowedData.length; i++){
                    for(var j=0; j<this.groupdataToSelect.length; j++){
                        if(this.allAllowedData[i]===this.groupdataToSelect[j].idWeweb){
                            this.building.groupdata.push({idWeweb:this.allAllowedData[i]});
                        }
                    }
                    for(var k=0; k<this.userdataToSelect.length; k++){
                        if(this.allAllowedData[i]===this.userdataToSelect[k].idWeweb){
                            this.building.userdata.push({idWeweb:this.allAllowedData[i]});
                        }
                    }
                }                    
            }
        },
        methods:{
            inChargeNbInc(){
                this.inChargeNb = this.inChargeNb +1;
            },
            userAllowedInc(){
                this.userAllowed = this.userAllowed +1;
            },
            bindUsergroup(index){
                return this.building.groupdata[index];
            },
            openModal(){
                this.$modal.show('validationModal');
            },
            closeModal(){
                this.$modal.hide('validationModal');
            },
            okButton(){
                if(this.validationPhrase === "Le Nouveau bien a été correctement enregistré"){
                    this.goToBuildingDetailPage(this.building.name);
                }
                else{
                    this.$modal.hide('validationModal');
                }
            },
            occupantAddressNbInc(){
                this.building.occupantAddress.push({
                            streetNb:      "",
                            streetName:    "",
                            postalCode:   "",
                            city:         "",
                            firstName :    "",
                            lastName:     "",
                            phoneNumber:  "",
                            company:      "",
                            emailAddress: ""});
            },
            backbtn(){

                var strHist = this.$cookie.get('history');
                var arrHist = JSON.parse(strHist);
                var strQuery = this.$cookie.get('historyQuery');
                var arrQuery = JSON.parse(strQuery);
                
                this.$cookie.set('history', JSON.stringify(arrHist.slice(0, -1)));
                this.$cookie.set('historyQuery', JSON.stringify(arrQuery.slice(0, -1)));

                if(arrHist.length){
                    if(arrQuery[arrQuery.length-1] !== "" && arrQuery[arrQuery.length-1] !== "undefined"){
                        this.$router.replace({ name: arrHist[arrHist.length-1], query: {name: arrQuery[arrQuery.length-1]} });
                    }
                    else{
                        this.$router.replace({ name: arrHist[arrHist.length-1] });
                    }
                }
                else{
                    this.$cookie.set('currentAriane', "");
                    this.$router.replace({ name: "adminhome" });
                }
            },
            async uploadPicture(id){
                const fd = new FormData();
                fd.append('picture', this.resizedFile ,'picture');
                
                var response = await axios.put('https://so.gaviota.fr/api/building/picture/'+id, fd);
                
                if(response){
                    this.validationPhrase =  "Le Nouveau bien a été correctement enregistré",
                    this.imgValidation = "/assets/right.png",
                    this.openModal();
                }
                else{
                    this.validationPhrase =  "Une erreur s'est produite, veuillez réessayer",
                    this.imgValidation = "/assets/wrong.png",
                    this.openModal();
                }
            },
            async getAllBuildingsNames(){

                                
                var response = await axios.get('https://so.gaviota.fr/api/building/admin/name');
                
                if(response){
                    this.allBuldingName = response.data.buildings;
                }
            },
            async uploadBuilding(){

                if( this.building.buildingAddress.streetName !== "" && this.building.buildingAddress.city !== "" && this.building.buildingAddress.postalCode !== ""){
                                        
                    var splitAddress = this.building.buildingAddress.streetName.split(" ");

                    this.building.buildingAddress.streetNb = parseInt(splitAddress[0]) || 0;

                    if(parseInt(splitAddress[0])){
                        this.building.buildingAddress.streetName = splitAddress.slice(1).join(" ")
                    }

                    var BuildingName = ""+this.building.buildingAddress.streetNb;       

                    for(var j =1; j<splitAddress.length; j++){
                        BuildingName += ""+splitAddress[j].substr(0,1);
                    }

                    BuildingName += ""+this.building.buildingAddress.postalCode;

                    if(this.building.complement !== ""){
                        var splitComplement = this.building.complement.split(" ");
                        for(var k =0; k<splitComplement.length; k++){
                            BuildingName += ""+splitComplement[k].substr(0,1);
                        }
                    }

                    if(this.building.residence !== ""){
                        var splitresidence = this.building.residence.split(" ");
                        for(var l =0; l<splitresidence.length; l++){
                            BuildingName += ""+splitresidence[l].substr(0,1);
                        }
                    }

                    BuildingName += ""+ this.building.etage;

                    var isBuildingNameUnique = false;
                    while(!isBuildingNameUnique){
                        isBuildingNameUnique = true;
                        for(var i = 0; i<this.allBuldingName.length; i++){
                            if(BuildingName === this.allBuldingName[i].name){
                                isBuildingNameUnique = false;

                                if(this.allBuldingName[i].name.slice(-2).substr(0,1) !== "_"){
                                    BuildingName = BuildingName+"_b";
                                }
                                else if(this.allBuldingName[i].name.slice(-2) === "_b"){
                                    BuildingName = BuildingName.substr(0, BuildingName.length-2)+"_t";
                                }
                                else if(this.allBuldingName[i].name.slice(-2).slice(-2) === "_t"){
                                    BuildingName = BuildingName.substr(0, BuildingName.length-2)+"_q";
                                }
                                else if(this.allBuldingName[i].name.slice(-2).slice(-2) === "_q"){
                                    BuildingName = BuildingName.substr(0, BuildingName.length-2)+"_p";
                                }
                                else if(this.allBuldingName[i].name.slice(-2).slice(-2) === "_p"){
                                    BuildingName = BuildingName.substr(0, BuildingName.length-2)+"_h";
                                }
                                else if(this.allBuldingName[i].name.slice(-2).slice(-2) === "_h"){
                                    BuildingName = BuildingName.substr(0, BuildingName.length-2)+"_s";
                                }
                                else if(this.allBuldingName[i].name.slice(-2).slice(-2) === "_s"){
                                    BuildingName = BuildingName.substr(0, BuildingName.length-2)+"_o";
                                }
                                else if(this.allBuldingName[i].name.slice(-2).slice(-2) === "_o"){
                                    BuildingName = BuildingName.substr(0, BuildingName.length-2)+"_n";
                                }
                                else if(this.allBuldingName[i].name.slice(-2).slice(-2) === "_n"){
                                    BuildingName = BuildingName.substr(0, BuildingName.length-2)+"_d";
                                }
                                else if(this.allBuldingName[i].name.slice(-2).slice(-2) === "_d"){
                                    BuildingName = BuildingName.substr(0, BuildingName.length-2)+"_u";
                                }
                                else{
                                    BuildingName = BuildingName.substr(0, BuildingName.length-2)+ Math.round(new Date().getTime()/1000);
                                }
                            }
                        }
                    }    
                    
                    this.building.name = BuildingName.toLowerCase();

                    var response = await axios.post('https://so.gaviota.fr/api/building/', {building: this.building});

                    if(response){
                        if(this.files.length){
                            this.uploadPicture(response.data.building._id);
                        }
                        else{
                            this.validationPhrase =  "Le Nouveau bien a été correctement enregistré",
                            this.imgValidation = "/assets/right.png",
                            this.openModal();
                        }
                    }
                    else{
                        this.validationPhrase =  "Une erreur s'est produite, veuillez réessayer",
                        this.imgValidation = "/assets/wrong.png",
                        this.openModal();
                    }
                }
                else{
                    this.validationPhrase =  "Veuillez remplir les champs obligatoires * ",
                    this.imgValidation = "/assets/wrong.png",
                    this.openModal();
                }
            },
            resizeImg(event){

                this.files = event.target.files;
                var current_file = this.files[0];
                var reader = new FileReader();

                var vm = this;
                
                reader.onload = function (event) {
                    var image = new Image();
                    image.src = event.target.result;
                    image.onload = function() {
                        var maxWidth = 500,
                            maxHeight = 250,
                            imageWidth = image.width,
                            imageHeight = image.height;
                        if (imageWidth > imageHeight) {
                            if (imageWidth > maxWidth) {
                                imageHeight *= maxWidth / imageWidth;
                                imageWidth = maxWidth;
                            }
                        }
                        else {
                            if (imageHeight > maxHeight) {
                                imageWidth *= maxHeight / imageHeight;
                                imageHeight = maxHeight;
                            }
                        }
                        var canvas = document.createElement('canvas');
                        canvas.style.display = "none";
                        canvas.width = imageWidth;
                        canvas.height = imageHeight;
                        image.width = imageWidth;
                        image.height = imageHeight;
                        var ctx = canvas.getContext("2d");
                        ctx.drawImage(this, 0, 0, imageWidth, imageHeight);

                        var BASE64_MARKER = ';base64,';
                        var raw;
                        var contentType;
                        var parts;
                        if (canvas.toDataURL(current_file.type).indexOf(BASE64_MARKER) == -1) {
                            parts = canvas.toDataURL(current_file.type).split(',');
                            contentType = parts[0].split(':')[1];
                            raw = parts[1];
                            vm.resizedFile = new File([new Blob([raw], {type: contentType})], "name", {type: vm.fileType, lastModified: vm.lastModified});
                        }
                        else{
                            parts = canvas.toDataURL(current_file.type).split(BASE64_MARKER);
                            contentType = parts[0].split(':')[1];
                            raw = window.atob(parts[1]);
                            var rawLength = raw.length;
                            var uInt8Array = new Uint8Array(rawLength);

                            for (var i = 0; i < rawLength; ++i) {
                                uInt8Array[i] = raw.charCodeAt(i);
                            }
                            vm.resizedFile = new File([new Blob([uInt8Array], {type: contentType})], "name", {type: vm.fileType, lastModified: vm.lastModified});
                        }
                    }
                }
                reader.readAsDataURL(current_file);
                
            },
            readURL(event) {
                this.imgUrl = URL.createObjectURL(event.target.files[0]);
                this.files = event.target.files;
                this.lastModified = event.target.files[0].lastModifiedDate;
                this.fileType = event.target.files[0].type;
                
                var extension = this.files[0].name.substring(this.files[0].name.lastIndexOf(".")+1).toLowerCase();
                if(extension !== "jpg" && extension !== "png" && extension !== "jpeg" && extension !== "gif"){
                    alert("Image au mauvais format, veuillez réessayer avec un fichier PNG ou JPG");
                }
                this.resizeImg(event);
            },
            goToBuildingDetailPage(name){
                var strHist = this.$cookie.get('history');
                var arrHist = JSON.parse(strHist);

                var strQuery = this.$cookie.get('historyQuery');
                var arrQuery = JSON.parse(strQuery);

                arrHist.push(this.$route.path.substr(1));
                strHist = JSON.stringify(arrHist);
                this.$cookie.set('history', strHist);

                arrQuery.push(this.$route.query.name);
                strQuery = JSON.stringify(arrQuery);
                this.$cookie.set('historyQuery', strQuery);

                this.$router.replace({ name: "buildingdetail", query: {name: name}  });
            },
            goToBuildingPage(){
                var strHist = this.$cookie.get('history');
                var arrHist = JSON.parse(strHist);

                var strQuery = this.$cookie.get('historyQuery');
                var arrQuery = JSON.parse(strQuery);

                arrHist.push(this.$route.path.substr(1));
                strHist = JSON.stringify(arrHist);
                this.$cookie.set('history', strHist);

                arrQuery.push(this.$route.query.name);
                strQuery = JSON.stringify(arrQuery);
                this.$cookie.set('historyQuery', strQuery);

                this.$router.replace({ name: "buildinglist"});
            },
            goToNewBuildingPage(){
                var strHist = this.$cookie.get('history');
                var arrHist = JSON.parse(strHist);

                var strQuery = this.$cookie.get('historyQuery');
                var arrQuery = JSON.parse(strQuery);

                arrHist.push(this.$route.path.substr(1));
                strHist = JSON.stringify(arrHist);
                this.$cookie.set('history', strHist);

                arrQuery.push(this.$route.query.name);
                strQuery = JSON.stringify(arrQuery);
                this.$cookie.set('historyQuery', strQuery);

                this.$router.replace({ name: "newbuilding"});
            },
            goToPlanningPage(){
                var strHist = this.$cookie.get('history');
                var arrHist = JSON.parse(strHist);

                var strQuery = this.$cookie.get('historyQuery');
                var arrQuery = JSON.parse(strQuery);

                arrHist.push(this.$route.path.substr(1));
                strHist = JSON.stringify(arrHist);
                this.$cookie.set('history', strHist);

                arrQuery.push(this.$route.query.name);
                strQuery = JSON.stringify(arrQuery);
                this.$cookie.set('historyQuery', strQuery);

                this.$router.replace({ name: "planningadmin"});
            },
            goToTimeSheetPage(){
                var strHist = this.$cookie.get('history');
                var arrHist = JSON.parse(strHist);

                var strQuery = this.$cookie.get('historyQuery');
                var arrQuery = JSON.parse(strQuery);

                arrHist.push(this.$route.path.substr(1));
                strHist = JSON.stringify(arrHist);
                this.$cookie.set('history', strHist);

                arrQuery.push(this.$route.query.name);
                strQuery = JSON.stringify(arrQuery);
                this.$cookie.set('historyQuery', strQuery);

                this.$router.replace({ name: "timesheet"});
            },
            goToAllUserPage(){
                var strHist = this.$cookie.get('history');
                var arrHist = JSON.parse(strHist);

                var strQuery = this.$cookie.get('historyQuery');
                var arrQuery = JSON.parse(strQuery);

                arrHist.push(this.$route.path.substr(1));
                strHist = JSON.stringify(arrHist);
                this.$cookie.set('history', strHist);

                arrQuery.push(this.$route.query.name);
                strQuery = JSON.stringify(arrQuery);
                this.$cookie.set('historyQuery', strQuery);

                this.$router.replace({ name: "alluser"});
            },
            goToNewUserPage(){
                var strHist = this.$cookie.get('history');
                var arrHist = JSON.parse(strHist);

                var strQuery = this.$cookie.get('historyQuery');
                var arrQuery = JSON.parse(strQuery);

                arrHist.push(this.$route.path.substr(1));
                strHist = JSON.stringify(arrHist);
                this.$cookie.set('history', strHist);

                arrQuery.push(this.$route.query.name);
                strQuery = JSON.stringify(arrQuery);
                this.$cookie.set('historyQuery', strQuery);

                this.$router.replace({ name: "newuser"});
            },
            goToAllGroupPage(){
                var strHist = this.$cookie.get('history');
                var arrHist = JSON.parse(strHist);

                var strQuery = this.$cookie.get('historyQuery');
                var arrQuery = JSON.parse(strQuery);

                arrHist.push(this.$route.path.substr(1));
                strHist = JSON.stringify(arrHist);
                this.$cookie.set('history', strHist);

                arrQuery.push(this.$route.query.name);
                strQuery = JSON.stringify(arrQuery);
                this.$cookie.set('historyQuery', strQuery);

                this.$router.replace({ name: "allgroup"});
            },
            goToNewGroupPage(){
                var strHist = this.$cookie.get('history');
                var arrHist = JSON.parse(strHist);

                var strQuery = this.$cookie.get('historyQuery');
                var arrQuery = JSON.parse(strQuery);

                arrHist.push(this.$route.path.substr(1));
                strHist = JSON.stringify(arrHist);
                this.$cookie.set('history', strHist);

                arrQuery.push(this.$route.query.name);
                strQuery = JSON.stringify(arrQuery);
                this.$cookie.set('historyQuery', strQuery);

                this.$router.replace({ name: "newgroup"});
            },
            refresh(){
                location.reload();
            },
            openNav(){
                 
                if(!this.navWidth){
                    this.navWidth = 300;
                }
                else{
                    this.navWidth = 0;
                }
                
                var vm = this;
                setTimeout(function(){
                    vm.navMenuVisible = !vm.navMenuVisible;
                }, 100);
            },
            logout() {
                this.$cookie.delete('jwt');
                this.$cookie.delete('role');
                this.$cookie.delete('firstName');
                this.$cookie.delete('lastName');
                this.$cookie.delete('currentAriane');
                this.$cookie.delete('historyQuery');
                this.$cookie.delete('history');
                this.$router.replace({ name: "login" });
            },
            reload() {
                this.$cookie.set('currentAriane', "");
                this.$cookie.set('history', "");
                this.$cookie.set('historyQuery', "");
                this.$router.replace({ name: "adminhome" });
            },
            getCookies: function() {
                this.$cookie.set('currentAriane', "Bien n° " +this.$route.query.name);
                this.filAriane = this.$cookie.get('currentAriane');
                if(!this.$cookie.get('jwt') || !this.$cookie.get('role') || (this.$cookie.get('role') !== "admin" && this.$cookie.get('role') !== "technicien bureau")){
                    this.$router.replace({ name: "login" });
                }
                else{
                    this.Name = this.$cookie.get('firstName') +" "+this.$cookie.get('lastName');
                    this.getUserData();
                }
            },
            async getUserData(){
                axios.defaults.headers.common['Authorization'] = this.$cookie.get('jwt');
                var response = await axios.get('https://so.gaviota.fr/api/userdata/admin/all');
                this.getGroupData();
                if(response.data.users){
                    for(var i=0; i<response.data.users.length; i++){
                        if(response.data.users[i].role === "admin" || response.data.users[i].role.indexOf("tech") > -1 ){
                            this.inchargeToSelect.push(response.data.users[i]);
                        }
                        else if(response.data.users[i].role === "client"){
                            this.userdataToSelect.push(response.data.users[i]);
                        }
                    } 
                    this.getAllBuildingsNames();                 
                }
            },
            async getGroupData(){
                axios.defaults.headers.common['Authorization'] = this.$cookie.get('jwt');
                var response = await axios.get('https://so.gaviota.fr/api/groupdata/admin/all');
                if(response.data.groups){
                    for(var i=0; i<response.data.groups.length; i++){
                        this.groupdataToSelect.push(response.data.groups[i]);
                    }                
                }
            }
        },
        mounted(){
            this.getCookies();
        }
    }
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css?family=BenchNine');
    #newbuilding {
        width: 90%;
        background-color: #FFFFFF;
        margin: auto;
        margin-top: 60px;
        margin-bottom: 30px;
        border:none;
    }
    h1{
        background-color: #1ce83e;
        font-family: 'BenchNine', sans-serif;
        font-stretch: ultra-condensed;
        padding-bottom:15px;
        padding-top:15px;
        margin:0;
        font-size: 30px;
        font-weight: 600;
        display: block;
        text-align: center;
        position:relative;
    }
    @media screen and (max-width: 768px) {
        .h1 {
              font-size: 24px;
            }
    }
    h2{
        font-family: 'BenchNine', sans-serif;
        font-stretch: ultra-condensed;
        padding:15px;
        font-size: 24px;
        font-weight: 600;
        display: block;
        border-bottom: 2px solid #1ce83e6e;
    }
    nav{
        top:0px;
        left:0px;
        right:0px;
        margin: 0px;
        position:fixed;
        z-index:1;
        width:100%;
        background-color: white;
        border-bottom: 2px solid;
        border-color:#1ce83e;
    }
    .main{
        display: inline-block; 
        cursor: pointer;
        margin:5px;
    }

    .rightNav {
        position:absolute;
        top:0;
        right:0;
    }
    .innerNav {
        display: inline-block;
        position: relative;
    }

    .logoNav{
        vertical-align: middle;
        margin:5px;    
    }
    .navLogout{
        height: 20px;
        vertical-align: middle;
        cursor: pointer;
        margin:24px;
    }
    .leftNav{
        position:absolute;
        top:0;
        left:0;
    }   
    .pNav {
        display:inline-block;
        padding-right:15px;
        font-family: 'BenchNine', sans-serif;
        font-size: 20px;
        vertical-align: middle;
    }
    @media screen and (max-width: 768px) {
        .pNav {
              display: none;
            }
    }
    .homeName{
        margin:auto;
        font-family: 'BenchNine', sans-serif;
        font-size: 20px;
        text-align: center;
        margin:10px;
    }
    #circle {
        width: 10px;
        height: 10px;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        border-radius: 5px;
        background: #1ce83e;
        margin:auto;
    }
    .outercircle{
        background-color: #F0F0F0;
        padding:50px;
    }
    .outermargin{
        background-color: #F0F0F0;
        padding:15px;
    }
    
    .btn{
        font-family: 'BenchNine', sans-serif;
        font-stretch: ultra-condensed;
        font-weight: 400;
        font-size: 20px;
        border:none;
        color:#1ce83e;
        cursor: pointer;
        background-color: black;
        border-radius:10px;
        display: inline-block;
        width: 100px;
    }
    .left{
        float:left;
    }
    .right{
        float:right;
    }
    .imgCard{
        width:100%;
        height: 200px;
        object-fit: cover;
        cursor: pointer;
    }
    .btnCard{
        width:20px;
        height: 20px;
        border-radius: 50%;
        font-stretch: ultra-condensed;
        font-size: 15px;
        border:none;
        color:#1ce83e;
        cursor: pointer;
        background-color: black;
        display:inline-block;
        position: absolute;
        top: 50%;
        right: 20px;
        -ms-transform: translateY(-50%);
        transform: translateY(-50%);
    }
    #circleRed {
        width: 10px;
        height: 10px;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        border-radius: 5px;
        background: #ff0000;
        display:inline-block;
        position: absolute;
        top: 50%;
        right: 60px;
        -ms-transform: translateY(-50%);
        transform: translateY(-50%);
    }
    .divCard{
        vertical-align: middle;
        position: relative;
        background-color: #F0F0F0;
        border-bottom: 2px solid;
        border-color:#1ce83e28;
        padding:10px;
        margin:2px;
    }
    .spanCard{
        display:inline-block;
        padding-left:5px;
        font-family: 'BenchNine', sans-serif;
        vertical-align: middle;
        font-size: 17px;
    }
    @media screen and (max-width: 768px) {
        .spanCard {
              font-size: 14px;
            }
    }
   .btnAccordion{
        font-family: 'BenchNine', sans-serif;
        font-size: 18px;
        font-weight: 700;
        border:none;
        cursor: pointer;
        width: calc(100% - (5px + 5px));
        display: inline-block;
        text-align: left;
        background-color: #FFF;
        margin: 5px;
    }
    .btnAccordionNone{
        cursor: default;
        padding-left:15px;
    }
   .btnBack{
        border:none;
        cursor: pointer;
        display: inline-block;
        text-align: left;
        background-color: #1ce83e;
        font-size: 30px;
        position: absolute;
        left: 1%;
        top: 50%;
        -ms-transform: translateY(-50%);
        transform: translateY(-50%);
    }
    .notifList{
        margin-bottom: 10px;
    }
    .container{
        padding: 20px;
        font-size: 17px;
        font-family: 'BenchNine', sans-serif;
        -webkit-column-count: 2; /* Old Chrome, Safari and Opera */
        -moz-column-count: 2; /* Old Firefox */
        column-count: 2;
    }
    .btnContainer{
        padding:20px;
        background-color: #FFF;
        margin-bottom: 20px;
        text-align: center;
    }
    hr{
        margin-bottom: 0px;
        border-color: rgba(240, 240, 240, 0.3);
        color: rgba(240, 240, 240, 0.3);
    }
    .filAriane{
        background-color: #F0F0F0;
        font-family: 'BenchNine', sans-serif;
        padding-top:20px;
        margin-left:-50px;
        margin-bottom:-17px;
        font-size: 17px;
    }		
    .sideNav{
        background-clip: border-box;
        background-color: #FFF;
        background-origin: padding-box;
        box-sizing: border-box;
        background-color: #333;
        display: block;
        height: 100%;
        overflow:auto;
        box-shadow: 8px 0px 6px -6px #999;
        position:fixed;
        top:0;
        left:0;
        z-index:10;
        -webkit-transition: width 0.5s;
        transition: width 0.5s;
    }
    .navsidecontent{
        color:white;
        font-family: 'BenchNine', sans-serif;
        margin-top:65px;
        margin-left:30px;
        margin-right:30px;
        -webkit-transition: width 0.5s;
        transition: width 0.5s;
    }
    .navtitle{
        margin:10px;
        margin-top:15px;
        padding-top:5px;
        font-size: 24px;
        font-weight: 700;
        text-align: center;
        border-top: 1px solid;
        border-color:#eee;
        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        cursor:default;
                              
    }
    .navsubtitle{
        margin:7px;
        font-size: 18px;
        font-weight: 400;
        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        cursor:pointer;
    }
    .navsubtitle:hover{
        color:#999;
    }
    .noborder{
        border:none;
        margin-top:5px;
        padding-top:0px;
    }
    .logout{
        padding-top:50px;
        cursor:pointer;
    }
    .textline{
        padding:5px;
    }
    
	/* width */
	::-webkit-scrollbar {
		width: 6px;
	}
	
	/* Track */
	::-webkit-scrollbar-track {
		background: #ddd; 
	}
	
	/* Handle */
	::-webkit-scrollbar-thumb {
		background: #888; 
		border-radius: 3px;
	}
	
	/* Handle on hover */
	::-webkit-scrollbar-thumb:hover {
		background: #555; 
	}
    .editBtn{
        width:30px;
        height: 30px;
        position:absolute;
        bottom:20px;
        right:20px;
        cursor:pointer;
    }
    .inputTxt{
        width:150px;
        font-family: 'BenchNine', sans-serif;
        font-stretch: ultra-condensed;
        font-size: 18px;
        background-color: #F7F7F7;
        border: 1px solid #bbb;
        padding-left:5px;
        margin-left:5px;
        display: inline-block;
    }
    .inlineBlock{
        display: inline-block;
    }
    .btnNewBtn{
        width:25px;
        height: 25px;
        border-radius: 50%;
        font-stretch: ultra-condensed;
        font-size: 15px;
        border:none;
        color:black;
        cursor: pointer;
        background-color: #1ce83e;
        display:inline-block;
        margin:10px;
    }
    .area{
        resize: none;
        width:100%;
    }
    .select{
        width:157px;
        margin-bottom:10px;
    }
    h3{
        font-family: 'BenchNine', sans-serif;
        font-stretch: ultra-condensed;
        margin: 0px 0px 0px 15px;
    }
    .textLen{
        width:120px;
        display: inline-block;
    }
    .radioBtn{
        margin-left:10px;
        margin-right:5px;
    }
    input[type='radio']:after {
        width: 15px;
        height: 15px;
        border-radius: 15px;
        top: -2px;
        left: -1px;
        position: relative;
        background-color: #d1d3d1;
        content: '';
        display: inline-block;
        visibility: visible;
        border: 1px solid grey;
    }
    input[type='radio']:checked:after {
        width: 15px;
        height: 15px;
        border-radius: 15px;
        top: -2px;
        left: -1px;
        position: relative;
        background: radial-gradient(#1ce83e, #ddd);
        content: '';
        display: inline-block;
        visibility: visible;
        border: 1px solid grey;
    }
    .blockBtn{
        font-family: 'BenchNine', sans-serif;
        font-stretch: ultra-condensed;
        display: block;
    }
    .modalDiv{
        margin:30px;
        text-align: center;
    }
    .modalTxt{
        font-family: 'BenchNine', sans-serif;
        font-stretch: ultra-condensed;
        font-size: 18px;
    }
    .txtDiv{
        margin-bottom: 15px; 
    }
    .docBtn3{
        font-family: 'BenchNine', sans-serif;
        font-stretch: ultra-condensed;
        display: inline-block;
        border:none;
        color:#1ce83e;
        font-size: 18px;
        cursor: pointer;
        background-color: black;
        border-radius:10px;
        width: 200px;
    }
    .allselects{
        display:inline-block;
    }
</style>